import { FormGroup, Input } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import Resizer from "react-image-file-resizer";

import {
  removeBotImage,
  setBotImageFile,
  setBotImagePreview,
} from "../../redux/botSlice";
import { TrashIcon } from "../../../../constants/icon_path";

const UploadBotProfileImage = () => {
  const dispatch = useDispatch();
  const { uploadPreview, updateForm } = useSelector((state) => state.bot);

  const handleImage = (e) => {
    const file = e.target.files[0];
    dispatch(setBotImagePreview(window.URL.createObjectURL(file)));
    Resizer.imageFileResizer(file, 720, 500, "JPEG", 100, 0, async (uri) => {
      dispatch(setBotImageFile(uri));
    });
  };

  const handleRemoveImage = () => dispatch(removeBotImage());

  return (
    <FormGroup>
      <label>ເລືອກຮູບ</label>
      <Input
        type="file"
        name="imageUrl"
        onChange={handleImage}
        accept="image/*"
      />
      {uploadPreview ? (
        <div className="m-2">
          <span className="text-center">
            <TrashIcon size={30} color="red" onClick={handleRemoveImage} />
          </span>
          <img className="img-thumbnail" src={uploadPreview} alt="message " />
        </div>
      ) : (
        <div className="m-2">
          <img
            className="img-thumbnail"
            src={updateForm?.imageUrl}
            alt="message "
          />
        </div>
      )}
    </FormGroup>
  );
};

export default UploadBotProfileImage;
